import React, { useState, useEffect, useContext, useMemo, useCallback, useRef } from 'react'
import ReactPlayer from 'react-player/lazy'
import Slider from 'react-slick'
import CustomCommonContext from '../../../context/common/commonContext'
import './Banner.css'
import Loaders from '@/custom/components/molecules/Loaders'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { detectFileType } from '@/product/common/components'

const Banner = () => {
    const customCommonContext = useContext(CustomCommonContext)
    const { allHomeBanner } = customCommonContext
    const isMobile = useMediaQuery('(max-width:767px)')
    const [active, setActive] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    const NextArrow = useCallback(
        ({ onClick, fill = 'white' }) => (
            <button type="button" className="slick-next" onClick={onClick}>
                <svg
                    width="20"
                    height="30"
                    viewBox="0 0 7 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M0 10H3.22L6.79 5L3.22 0H0L3.58 5L0 10Z" fill={fill} />
                </svg>
            </button>
        ),
        [],
    )

    const PrevArrow = useCallback(
        ({ onClick, fill = 'white' }) => (
            <button type="button" className="slick-prev" onClick={onClick}>
                <svg
                    width="20"
                    height="30"
                    viewBox="0 0 7 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6.78906 10H3.56906L-0.000937462 5L3.56906 0H6.78906L3.20906 5L6.78906 10Z"
                        fill={fill}
                    />
                </svg>
            </button>
        ),
        [],
    )

    const [currentSlide, setCurrentSlide] = useState(0)
    const settingsBanner = useMemo(
        () => ({
            dots: false,
            fade: true,
            infinite: true,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            speed: 1500,
            autoplaySpeed: 5000,
            initialSlide: 0, // starts from the first slide
            cssEase: 'ease-in-out',
            pauseOnHover: false,
            nextArrow: <NextArrow />,
            prevArrow: <PrevArrow />,
            beforeChange: (current, next) => setCurrentSlide(next),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        arrows: false,
                        infinite: true,
                        fade: true,
                        initialSlide: 0,
                    },
                },
            ],
        }),
        [NextArrow, PrevArrow],
    )

    useEffect(() => {
        if (allHomeBanner) {
            const activeBanners = allHomeBanner
                .filter((item) => item.active === 1)
                .sort((a, b) => a.show_order - b.show_order)

            setActive(activeBanners)

            setTimeout(() => {
                setIsLoading(false)
            }, 200)
        }
    }, [allHomeBanner])

    const handleBannerItemClick = (bannerItem) => {
        console.log('banner click value', bannerItem)
        if (!bannerItem) {
            console.warn('No banner item provided to handleBannerItemClick')
            return
        }

        const { link } = bannerItem

        if (!link) {
            console.warn('No link found for this banner (direct)')
            return
        }

        try {
            if (link.startsWith('http://') || link.startsWith('https://')) {
                window.open(link, '_blank')
            } else {
                const trimmedLink = link.trim()
                if (trimmedLink) {
                    window.open(`/${trimmedLink}`, '_blank')
                } else {
                    console.warn('Empty link after trim')
                }
            }
        } catch (error) {
            console.error('Error opening banner link (direct):', error)
        }
    }

    const renderBannerItems = useMemo(() => {
        if (!active || !active.length) return null

        return active.map((data, index) => {
            const imageUrl = `${global.site_url || ''}/uploads/banner/${
                isMobile && data.image_mobile ? data.image_mobile : data.image
            }`
            const fileType = detectFileType(imageUrl)

            return (
                <div
                    key={data.id || index}
                    className="position-relative bannerInner"
                    onDoubleClick={() => handleBannerItemClick(data)}
                    style={{
                        cursor: 'pointer',
                        width: '100%',
                        height: '100%',
                    }}
                >
                    {isLoading ? (
                        <div className="noGridLoader">
                            <Loaders isLoading={isLoading} name={'home'} />
                        </div>
                    ) : (
                        <>
                            {fileType === 'video' ? (
                                <ReactPlayer
                                    className="react-player"
                                    width="100%"
                                    height="100%"
                                    url={imageUrl}
                                    // light="./assets/images/noimage.jpg"
                                    playing
                                    stopOnUnmount={false}
                                    muted
                                    playsinline
                                    pip
                                    loop
                                />
                            ) : (
                                <img
                                    className="bannerImg"
                                    src={imageUrl}
                                    alt={`banner_${index}`}
                                    loading="eager"
                                    onError={(e) => {
                                        e.target.src = './assets/images/noimage.jpg'
                                    }}
                                />
                            )}
                            <div className="bannerContent">
                                {/* {data.title && <h1>{data.title}</h1>}
                                {data.description && <h3>{data.description}</h3>} */}
                            </div>
                        </>
                    )}
                </div>
            )
        })
    }, [active, isLoading, isMobile])

    return (
        <div className="heroCarousel">
            <Slider {...settingsBanner}>{renderBannerItems}</Slider>
        </div>
    )
}

export default React.memo(Banner)
